import React from 'react';

import { useTranslation } from 'react-i18next';
import { Button } from '@bringg/react-components';
import classNames from 'classnames';

import { ButtonsLoading, ModalParams } from './vehicle-assigner-modal-const';
import type { SelectedVehicleData } from './vehicle-trailer-list';

interface Props {
	modalParams: ModalParams;
	buttonsLoading: ButtonsLoading;
	unassignVehicles: () => void;
	unassignTrailer: () => void;
	okButton: () => void;
	selectedVehicle: Partial<SelectedVehicleData>;
	selectedTrailer: Partial<SelectedVehicleData>;
}

const VehicleAssignerModalFooter: React.FC<Props> = ({
	modalParams,
	buttonsLoading,
	unassignVehicles,
	unassignTrailer,
	okButton,
	selectedVehicle,
	selectedTrailer
}: Props) => {
	const { t } = useTranslation();
	const { vehicleId, trailerId } = modalParams.data;

	return (
		<div
			className={classNames('footer-buttons', { 'footer-single-button': modalParams.hideUnassignVehicleButton })}
		>
			{!modalParams.hideUnassignVehicleButton && (
				<div className="button-left-group">
					<Button
						className="unassign-vehicle"
						disabled={!vehicleId}
						type="link"
						loading={buttonsLoading.unassignVehicles}
						onClick={unassignVehicles}
					>
						{t('RUN_VEHICLE_ASSIGNMENT.UNASSIGN_VEHICLES')}
					</Button>

					{trailerId && (
						<Button
							className="unassign-trailer"
							type="link"
							disabled={!trailerId}
							loading={buttonsLoading.unassignTrailer}
							onClick={unassignTrailer}
						>
							{t('RUN_VEHICLE_ASSIGNMENT.UNASSIGN_TRAILER')}
						</Button>
					)}
				</div>
			)}

			<div className="button-right-group">
				<Button
					key="submit"
					type="primary"
					loading={buttonsLoading.ok}
					onClick={okButton}
					data-test-id="vehicles-modal-ok-button"
					disabled={
						(selectedVehicle?.id == null && selectedTrailer?.id == null) ||
						(selectedVehicle?.id === vehicleId && selectedTrailer?.id === trailerId)
					}
				>
					{t('RUN_VEHICLE_ASSIGNMENT.OK')}
				</Button>
			</div>
		</div>
	);
};

export default VehicleAssignerModalFooter;
